import { extractNumbers } from '@/utils/extract-numbers';

export const cpfMask = (cpf: string) => {
  const cpfNumber = extractNumbers(cpf);
  return cpfNumber.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};
